export default __webpack_public_path__ + "static/media/file-export-solid.10bc8da4.svg";